import { render, staticRenderFns } from "./RecipesView.vue?vue&type=template&id=3ac22d9c&scoped=true&lang=pug"
import script from "./RecipesView.vue?vue&type=script&lang=js"
export * from "./RecipesView.vue?vue&type=script&lang=js"
import style0 from "./RecipesView.vue?vue&type=style&index=0&id=3ac22d9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac22d9c",
  null
  
)

export default component.exports